var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 248,
    viewBox: "0 0 279 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.512 172.123C213.358 173.268 181.67 206.59 146.577 193.628C111.483 180.665 62.3176 210.346 41.3308 168.081C20.344 125.815 45.071 47.5018 107.131 40.3793C169.191 33.2568 237.508 41.5244 247.967 73.3925C256.879 101.012 266.425 119.803 214.512 172.123Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.874 135.636C131.874 135.636 114.656 171.728 113.128 173.364C103.206 184.242 96.3401 189.521 85.9554 200.058L83.8032 195.565C89.8941 184.18 95.533 170.776 103.895 170L118.573 135.77L131.874 135.636Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.7517 199.407L83.5987 210.699C83.5661 210.825 83.4919 210.938 83.3871 211.02C83.2823 211.102 83.1526 211.149 83.0175 211.154C82.9028 211.159 82.7887 211.135 82.6867 211.084C82.5848 211.033 82.4985 210.958 82.4364 210.865L81.1989 208.888C80.0169 207 79.4439 204.817 79.5524 202.615L79.8537 196.881C79.8727 196.41 80.0579 195.96 80.3788 195.605C80.6996 195.249 81.137 195.009 81.6186 194.925L84.4596 194.459C86.1491 195.349 86.8271 197.088 86.7517 199.458V199.407Z",
    fill: "#292A61"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.127 112.72C139.127 112.72 136.9 148.864 136.663 159.204C136.789 161.255 136.688 163.312 136.362 165.342C133.94 175.185 132.154 206.413 132.154 206.413C131.003 207.117 129.076 206.755 127.075 206.278C124.858 189.852 121.694 172.122 126.246 164.804L120.984 123.546L131.207 121.228L139.127 112.72Z",
    fill: "url(#paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.154 206.413L138.74 211.257C138.977 211.392 142.862 212.872 142.797 213.131C142.743 213.348 143.411 214.166 142.055 214.3L138.051 214.683C137.126 214.922 136.148 214.889 135.243 214.59L127.71 212.075C127.249 211.918 126.855 211.619 126.59 211.224C126.325 210.828 126.204 210.359 126.246 209.891L126.935 204.943C127.663 205.518 128.505 205.944 129.409 206.197C130.314 206.45 131.262 206.523 132.197 206.413H132.154Z",
    fill: "#292A61"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.316 108.394C119.316 108.394 110.233 116.125 108.995 125.513C107.758 134.901 107.866 157.186 107.866 157.186C107.866 157.186 122.824 161.647 138.525 157.424L139.773 109.812L119.316 108.394Z",
    fill: "url(#paint2_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.544 108C128.452 116.705 132.799 133.266 131.874 140.014C130.615 149.154 127.957 151.7 129.593 158.997C132.612 158.726 135.601 158.2 138.524 157.424L139.773 109.811L136.544 108Z",
    fill: "#18A8B8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.174 63.0475C116.066 63.1303 119.768 73.6879 125.988 71.7316C132.208 69.7754 126.096 57.4893 126.096 57.4893L116.174 63.0475Z",
    fill: "#292A61"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.567 83.8314L118.616 80.4675L141.312 70.21L149.071 52.8418L152.697 54.6635C152.697 54.6635 150.276 65.0141 148.554 71.2244C148.292 72.19 147.831 73.0948 147.196 73.8844C146.562 74.6741 145.768 75.3325 144.863 75.82L133.553 81.9372L124.567 83.79V83.8314Z",
    fill: "#FF714D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.233 88.3437L136.9 82.4335C136.9 82.4335 131.616 74.1531 131.293 74.2152C113.494 77.7344 117.497 88.8198 117.497 88.8198L123.233 88.3437Z",
    fill: "#FFA938"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.239 68.585L130.163 77.2691C130.104 77.7834 129.903 78.2733 129.582 78.6881C129.26 79.1029 128.829 79.4278 128.334 79.629C127.84 79.8215 127.303 79.8874 126.774 79.8202C126.246 79.7531 125.745 79.5553 125.32 79.2461L124.503 78.6354C123.919 78.2036 123.476 77.6209 123.224 76.9555C122.973 76.2901 122.923 75.5695 123.082 74.8781L125.417 64.6621L131.239 68.585Z",
    fill: "#FF714D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.927 71.0487C130.358 71.085 129.787 71.0121 129.248 70.8345C128.708 70.6568 128.211 70.3778 127.785 70.0137C127.785 70.0137 129.356 72.4771 130.701 72.9739L130.927 71.0487Z",
    fill: "#C44627"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.951 58.9701C120.863 58.5031 120.871 58.024 120.975 57.5601C121.079 57.0961 121.277 56.6564 121.558 56.2662C121.839 55.8759 122.197 55.5427 122.611 55.2856C123.026 55.0285 123.49 54.8525 123.975 54.7677L131.078 53.5153C131.567 53.4321 132.068 53.4428 132.553 53.5467C133.038 53.6507 133.497 53.8459 133.903 54.121C134.309 54.3962 134.654 54.7458 134.919 55.1499C135.184 55.554 135.363 56.0046 135.447 56.4756L137.308 66.2983C137.416 67.2981 137.151 68.3022 136.559 69.131C135.968 69.9597 135.089 70.5589 134.08 70.8215C130.593 71.7841 123.319 70.0762 122.964 68.12C122.415 65.2322 121.468 61.9096 120.919 59.0218L120.951 58.9701Z",
    fill: "#FF714D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.214 55.6263C153.214 55.6263 155.646 53.3078 157.895 51.01C160.349 48.5052 160.047 47.0768 157.217 45.8347C156.432 45.4724 154.096 46.2798 154.096 46.2798L150.997 49.9956C150.997 49.9956 146.886 53.7529 148.748 55.6574C150.61 57.5619 153.214 55.6263 153.214 55.6263Z",
    fill: "#FF714D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.871 57.6857C114.871 57.6857 123.749 44.7268 134.349 52.8727C134.349 52.8727 135.576 65.2209 116.625 64.7862C111.32 64.6619 114.871 57.6857 114.871 57.6857Z",
    fill: "#292A61"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M185.961 45.793H163.782C158.343 45.793 153.935 50.0332 153.935 55.2637V57.7996C153.935 63.0302 158.343 67.2704 163.782 67.2704H185.961C191.399 67.2704 195.807 63.0302 195.807 57.7996V55.2637C195.807 50.0332 191.399 45.793 185.961 45.793Z",
    fill: "#E9DEFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M185.961 73.0879H163.782C158.343 73.0879 153.935 77.3281 153.935 82.5587V85.0945C153.935 90.3251 158.343 94.5653 163.782 94.5653H185.961C191.399 94.5653 195.807 90.3251 195.807 85.0945V82.5587C195.807 77.3281 191.399 73.0879 185.961 73.0879Z",
    fill: "#E9DEFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M185.961 101.355H163.782C158.343 101.355 153.935 105.596 153.935 110.826V113.362C153.935 118.593 158.343 122.833 163.782 122.833H185.961C191.399 122.833 195.807 118.593 195.807 113.362V110.826C195.807 105.596 191.399 101.355 185.961 101.355Z",
    fill: "#E9DEFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.551 86.8642L130.981 80.2812L152.762 92.1947L169.291 88.8412L172.197 92.7019L156.055 98.4982C155.08 98.8466 154.042 99.0032 153.004 98.9587C151.965 98.9143 150.946 98.6697 150.007 98.2395L138.299 92.8675L131.562 86.8642H131.551Z",
    fill: "#FF714D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.054 96.2731L141.807 96.7079C141.807 96.7079 145.778 87.8064 145.563 87.5683C140.548 82.0411 136.502 79.4742 133.36 78.4909C132.404 78.1976 131.466 77.8521 130.551 77.4558C128.097 76.3276 124.385 77.0521 123.147 75.8515C122.824 75.5513 123.082 74.9199 123.082 74.9199L119.693 75.8308C118.978 76.1366 118.349 76.6009 117.857 77.1856C117.365 77.7703 117.024 78.4588 116.862 79.1947C115.786 86.5747 116.109 88.8621 117.82 96.2317C118.444 98.9229 118.896 106.52 118.121 108.652C115.829 114.697 139.967 114.076 140.236 111.333C139.95 108.907 139.889 106.462 140.053 104.026C140.301 101.397 140.731 98.6124 141.054 96.2731Z",
    fill: "url(#paint3_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.381 91.9047C173.381 91.9047 175.824 89.5862 178.062 87.2884C180.516 84.7835 180.215 83.3552 177.384 82.1131C176.609 81.7508 174.274 82.5685 174.274 82.5685L171.175 86.274C171.175 86.274 167.053 90.0416 168.926 91.9358C170.798 93.8299 173.381 91.9047 173.381 91.9047Z",
    fill: "#FF714D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.599 83.0555C177.599 83.0555 181.376 80.6231 180.698 79.0498C180.02 77.4765 174.242 82.5276 174.242 82.5276L175.931 85.0738L177.599 83.0555Z",
    fill: "#FF714D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.337 63.0282C120.002 62.4662 120.485 61.7317 120.728 60.9126C120.97 60.0935 120.962 59.2245 120.704 58.4098C120.446 57.595 119.95 56.869 119.274 56.3186C118.599 55.7683 117.772 55.4169 116.894 55.3066C115.575 55.1039 114.224 55.2658 112.997 55.7734C111.77 56.281 110.718 57.1134 109.964 58.1737C105.326 64.3841 95.8342 60.2439 94.446 69.932C93.2838 78.0572 81.328 72.0021 83.8784 85.9961C86.2136 98.7583 101.99 93.6244 102.689 87.8385C103.389 82.0525 102.947 77.964 107.865 77.0014C115.398 75.542 115.883 71.9711 115.807 67.748C115.775 65.7918 117.54 64.56 119.337 63.0282Z",
    fill: "#292A61"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.707 72.0012C123.707 72.0012 131.519 71.5354 129.087 59.891C126.655 48.2467 120.693 64.6316 120.693 64.6316L123.707 72.0012Z",
    fill: "#292A61"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.874 64.6632C131.874 65.2446 131.695 65.8129 131.359 66.2963C131.023 66.7797 130.546 67.1565 129.988 67.379C129.429 67.6015 128.815 67.6597 128.222 67.5463C127.629 67.4328 127.084 67.1529 126.657 66.7418C126.23 66.3307 125.939 65.8069 125.821 65.2367C125.703 64.6665 125.763 64.0754 125.995 63.5383C126.226 63.0011 126.618 62.542 127.12 62.219C127.623 61.896 128.214 61.7236 128.818 61.7236C129.628 61.7264 130.404 62.0369 130.976 62.5876C131.549 63.1383 131.871 63.8844 131.874 64.6632Z",
    fill: "#FF714D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.24
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.054 96.2731C140.731 98.6123 140.301 101.397 140.053 104.015C139.889 106.452 139.95 108.897 140.236 111.323C140.139 112.234 137.427 112.917 133.919 113.186C134.995 112.151 136.9 110.35 135.663 103.87C135.06 100.765 136.018 97.2046 135.932 92.7021L141.054 96.2731Z",
    fill: "#BF6C1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 99.1811,
    y1: 182.845,
    x2: 120.974,
    y2: 141.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF714D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F96C49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E7603E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#CB4B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#C44627"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 129.593,
    y1: 175.734,
    x2: 129.842,
    y2: 142.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF714D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#EC6341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#C44627"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 123.814,
    y1: 159.236,
    x2: 123.814,
    y2: 108.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75D8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#56BFD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#47B3CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 139.698,
    y1: 111.965,
    x2: 119.62,
    y2: 75.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FF7909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FF8B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FFA74C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#FFCD85"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListings);
export default __webpack_public_path__ + "static/media/Listings.e279bd30.svg";
export { ForwardRef as ReactComponent };